<template>
  <div id="active-flip-grid">
    <v-toolbar
      flat
    >
       <v-toolbar-title class="text-h5 pa-0">HOLD Investment Vehicles</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-select
          :items="sorts"
          v-model="listQuery.sort"
          label="Sort by"
          clearable
          dense
          class="mt-4 d-none d-sm-block"
          :loading='sortLoader'
          @change="performSort"
          ></v-select>
      </v-toolbar-items>
    </v-toolbar>
    <v-row v-if="flipAssetList">
      <v-col
        v-for="(asset, a) in flipAssetList.entries"
        :key="a"
        cols="12"
        md="3"
        sm="6"
        class="align-self-stretch"
      >
        <CarCard :asset="asset"></CarCard>
      </v-col>
    </v-row>
    <v-pagination
      v-if="flipAssetList && flipAssetList.totalResults > flipAssetList.pageSize"
      v-model="page"
      :length="Math.ceil(flipAssetList.totalResults / flipAssetList.pageSize)"
      class="mt-10"
    >
    </v-pagination>
  </div>
</template>

<script>
  import CarCard from '../components/CarCard.vue'
  import {mapGetters, mapActions } from 'vuex'

  export default {
    name: 'ActiveHoldGrid',

    components: {
      CarCard
    },

    computed: {
      ...mapGetters(['flipAssetList'])
    },

    data: () => ({
      // List query we'll pass to the state action.
      listQuery: {
        sort: null,
        offset: '0',
        pageSize: '18',
        salesModel: 'hold'
      },

      // Sort Handling
      sortLoader: false,
      sorts: [
        {
          text: 'Auction Date',
          value: 'auctionDate'
        },
        {
          text: 'Buy Now Price',
          value: 'buyNowPrice'
        },
        {
          text: 'Share Price',
          value: 'sharePrice'
        }
      ],

      // Pagination
      page: 1
    }),

    methods: {
      ...mapActions(['getFlipAssets']),

      performSort: function() {
        this.sortLoader = true
        this.getFlipAssets(this.listQuery).then(() => {
          this.sortLoader = false
        })
      }
    },

    created() {
      this.getFlipAssets(this.listQuery)
    }
  }
</script>
